import { createI18n } from 'vue-i18n'
import enUS from '../lang/en-US'
import zhCN from '../lang/zh-CN'
import { nextTick } from 'vue'

// 导入 Arco Design 的国际化文件
import enUSArco from '@arco-design/web-vue/es/locale/lang/en-us'
import zhCNArco from '@arco-design/web-vue/es/locale/lang/zh-cn'

// 支持的语言列表
export const languages = [
    { label: '中国站', value: 'zh-CN' },
    { label: 'English', value: 'en-US' }
]

// 合并 Arco Design 和自定义的国际化内容
const messages = {
    'zh-CN': { ...zhCNArco, ...zhCN },
    'en-US': { ...enUSArco, ...enUS }
}

// 获取本地存储的语言设置
const getSavedLanguage = () => {
    const saved = localStorage.getItem('arco-locale')
    return saved || 'zh-CN'
}

// 创建 i18n 实例
const i18n = createI18n({
    locale: getSavedLanguage(),
    fallbackLocale: 'zh-CN',
    messages,
    legacy: false, // 使用 Composition API
    globalInjection: true, // 全局注入 $t
    silentTranslationWarn: true
})

export default i18n